import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';
const api = axios.create({ baseURL: API_URL });

const K_ACCESS = 'bm_access';
const K_REFRESH = 'bm_refresh';

export function saveSession(d) {
  localStorage.setItem(K_ACCESS, d.accessToken);
  localStorage.setItem(K_REFRESH, d.refreshToken);
  if (d.user) localStorage.setItem('bm_user', JSON.stringify(d.user));
}
export function clearSession() {
  localStorage.removeItem(K_ACCESS);
  localStorage.removeItem(K_REFRESH);
  localStorage.removeItem('bm_user');
}
export function isLoggedIn() { return !!localStorage.getItem(K_REFRESH); }
export function getRefreshToken() { return localStorage.getItem(K_REFRESH); }
export function getUser() {
  try { return JSON.parse(localStorage.getItem('bm_user')); } catch (e) { return null; }
}

export function errMsg(err) {
  if (err?.response?.data?.message) return err.response.data.message;
  if (err?.response?.status === 403) return 'Nu ai drepturi pentru această acțiune.';
  if (err?.response) return 'A apărut o eroare. Încearcă din nou.';
  return 'Nu se poate contacta serverul. Verifică conexiunea la internet.';
}

api.interceptors.request.use(config => {
  const token = localStorage.getItem(K_ACCESS);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

function goToLogin() {
  clearSession();
  window.history.pushState({}, '', '/login');
  window.dispatchEvent(new PopStateEvent('popstate'));
}

const RUTE_PUBLICE = ['/api/auth/login', '/api/auth/refresh', '/api/auth/logout'];

// Reconectare silentioasa la 401; refresh-token-ul se roteste, deci cererile simultane asteapta prima reimprospatare.
let seReimprospateaza = false;
let coada = [];

function proceseazaCoada(eroare, tokenNou) {
  coada.forEach(({ resolve, reject, originalRequest }) => {
    if (eroare) { reject(eroare); return; }
    originalRequest.headers.Authorization = `Bearer ${tokenNou}`;
    resolve(api(originalRequest));
  });
  coada = [];
}

api.interceptors.response.use(
  res => res,
  async err => {
    const originalRequest = err.config;
    const publica = RUTE_PUBLICE.some(r => originalRequest?.url?.includes(r));
    if (err.response?.status === 401 && !publica && originalRequest && !originalRequest._retry) {
      const refreshToken = localStorage.getItem(K_REFRESH);
      if (!refreshToken) { goToLogin(); return Promise.reject(err); }
      originalRequest._retry = true;
      if (seReimprospateaza) {
        return new Promise((resolve, reject) => coada.push({ resolve, reject, originalRequest }));
      }
      seReimprospateaza = true;
      try {
        const r = await axios.post(`${API_URL}/api/auth/refresh`, { refreshToken });
        saveSession(r.data);
        seReimprospateaza = false;
        proceseazaCoada(null, r.data.accessToken);
        originalRequest.headers.Authorization = `Bearer ${r.data.accessToken}`;
        return api(originalRequest);
      } catch (eRefresh) {
        seReimprospateaza = false;
        proceseazaCoada(eRefresh, null);
        if (eRefresh.response) goToLogin();
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
